// Mapeamento entre os nós nomeados do modelo 3D (CarConcept.glb, Khronos
// glTF-Sample-Assets, CC BY 4.0 — ver atribuição em VehicleInspection3D.jsx)
// e as peças clicáveis do catálogo PARTES_VEICULO (avariaModel.js).
//
// O modelo já vem com nomenclatura "lógica" por peça (porta, capô, teto,
// retrovisores, rodas...), então o mapeamento é direto nó → peça. Nós sem
// correspondência (engine, eixos, bancos, painel interno) são ocultados —
// ver isHiddenNode — tanto por performance quanto porque vistoria de avaria
// externa não se aplica a peças internas/mecânicas.
export const NODE_TO_PARTE = {
  BodyHood: "hood",
  BodyHoodInterior01: "hood",
  BodyHoodInterior02: "hood",
  BodyHoodTopgrill: "hood",
  BodyHoodUnder: "hood",

  BodyHeadlights: "headlights",

  BodyWindshield: "windshield",
  BodyWindshieldGasket: "windshield",
  BodyWindshieldWipers: "windshield",
  BodyWindshieldWipersBase: "windshield",

  BodyRoofPanel: "roof",

  BodyDoorLMirror: "left_mirror",
  BodyDoorLMirrorColor1: "left_mirror",
  BodyDoorLMirrorColor2: "left_mirror",

  BodyDoorRMirror: "right_mirror",
  BodyDoorRMirrorColor1: "right_mirror",
  BodyDoorRMirrorColor2: "right_mirror",

  BodyDoorLColor1: "left_door",
  BodyDoorLColor2: "left_door",
  BodyDoorLHandle01: "left_door",
  BodyDoorLHandle02: "left_door",
  BodyDoorLWindow: "left_door",
  BodyDoorLWindowGasket: "left_door",

  BodyDoorRColor1: "right_door",
  BodyDoorRColor2: "right_door",
  BodyDoorRHandle01: "right_door",
  BodyDoorRHandle02: "right_door",
  BodyDoorRWindow: "right_door",
  BodyDoorRWindowGasket: "right_door",

  BodyWindowsRearSides: "rear_quarter_glass",
  BodyRearwindow: "rear_window",

  InteriorRearHatch: "trunk",

  BodyTaillights: "taillights",
  BodyTaillightsPanels: "taillights",
  BodyTurnsignalsRear: "taillights",

  BodyRearPanelsColor1: "rear_panel",
  BodyPillars: "rear_panel",

  BodyPanelsColor2: "side_panel",

  "License Plate": "license_plate",

  WheelFrontL: "wheel_front_left",
  WheelFrontR: "wheel_front_right",
  WheelRearL: "wheel_rear_left",
  WheelRearR: "wheel_rear_right",
};

// Nós sem peça externa correspondente: mecânica, interior, freios. Ocultos
// (visible = false) ao carregar o modelo — não aparecem nem são clicáveis.
// "BodyUnderside" (assoalho) é mantido visível porque também é o nó raiz da
// cena (ocultá-lo ocultaria toda a hierarquia filha).
export function isHiddenNode(name) {
  if (!name) return false;
  if (name === "Engine" || name === "Axles") return true;
  if (name.startsWith("Interior")) return true;
  if (name.includes("Brake")) return true;
  return false;
}

// Sobe a hierarquia de pais a partir do objeto clicado/sob o cursor até
// achar um nó presente no mapa — cobre tanto nós nomeados diretamente
// (a maioria) quanto filhos sem nome própria, como o pneu de cada roda
// (sobe até achar "WheelFrontL" etc.).
export function resolveParteKey(object3d) {
  let node = object3d;
  while (node) {
    const parte = NODE_TO_PARTE[node.name];
    if (parte) return parte;
    node = node.parent;
  }
  return null;
}

// Direções (unitárias, espaço do mundo) para os 5 ângulos de câmera
// predefinidos. A posição final da câmera é calculada em tempo de execução
// como centro_do_modelo + direção * raio_da_esfera_envolvente * fator —
// assim funciona independente da escala/unidades do GLB carregado.
export const CAMERA_DIRECTIONS = {
  frontal: { dir: [0, 0.32, 1], distFactor: 2.4 },
  traseira: { dir: [0, 0.32, -1], distFactor: 2.4 },
  lateral_esquerda: { dir: [-1, 0.32, 0.04], distFactor: 2.3 },
  lateral_direita: { dir: [1, 0.32, 0.04], distFactor: 2.3 },
  superior: { dir: [0.001, 1, 0.15], distFactor: 2.6 },
};

export const MODEL_URL = "/models/car-concept.glb";

export const MODEL_ATTRIBUTION =
  '"CarConcept" by Khronos Group (glTF-Sample-Assets), licenciado CC BY 4.0 — derivado de "Free Concept Car 004" por Unity Fan (Sketchfab, CC0).';
